document.addEventListener("DOMContentLoaded", function (event) {
  $("#searchstr").keypress(function (e) {
    if (e.which == 13) {
      pageSearch();
    }
  });
  $("#search_btn").click(function () {
    pageSearch();
  });
  function pageSearch() {
    var txt = $("#searchstr").val();
    var blank = true;
    if (txt != "") {
      var t = txt.split(" ");
      $(".download_list p").css("cssText", "display:none !important");
      $(".download_list p").each(function () {
        for (var i = 0; i < t.length; i++) {
          if (t[i] != "") {
            blank = false;
            if ($(this).html().indexOf(t[i]) >= 0) {
              $(this).css("cssText", "display:block");
            }
          }
        }
      });
      if (blank == true) {
        $(".download_list p").css("cssText", "display:block");
      }
    } else {
      $(".download_list p").css("cssText", "display:block");
    }
  }
});
